<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
      <v-layout row wrap justify-center class="">
      <DialogNotice ref="dlg"></DialogNotice>
      <v-flex xs12>
        <v-card class="ma-3">
        <v-data-table
          :headers="headers"
          :items="tableData"
          :pagination.sync="pagination"
          hide-actions
          item-key="name"
          class="peerTable edoFixedHeaderInTable colorrows"
        >
          <template v-slot:headers="props">
            <tr style="background-color: #004884; color:white">
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[getClassFor(header) + ' column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                style="background-color: #004884; color:white"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr class="TRrowBlue" v-if="showGroup(props.item)">
              <td class="text-xs-left font-weight-bold rowBlue blue" :colspan="headers.length">{{props.item.diffText}}
              </td>
            </tr>

            <tr :active="props.selected">
              <td :class="getClassFor(header)" @click="checkAbschlussExists(props.item)" v-for="header in headers" :key="header.id">
                <v-checkbox v-if="header.value === 'email'" label='' v-model='props.item.isEmail' @change="saveEmailNotification(props.item)"></v-checkbox>
                <span  v-if="header.value != 'email'" v-html="getValue(props.item, header)"></span>
                <span v-if="header.value === 'docTypes' && downloadDocumentWithTypExists('3', props.item)" class="">{{ 'REPORT_NEWSBOX_EXISTS' | translate}}</span>
                <span v-if="header.value === 'docTypes' && !downloadDocumentWithTypExists('3', props.item)" class="">{{ 'REPORT_NEWSBOX_MISSING' | translate}}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import DialogNotice from './../../module/dialogs/DialogNotice'
import Vue from 'vue'

var _ = require('lodash')

export default {
  name: 'NewsboxChanges',
  components: {DialogNotice},
  methods: {
    showGroup (item) {
      if (item.diffText !== null) {
        return true
      }
      return false
    },
    changeSort: function (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    toggleAll () {
      if (this.selected.length) {
        for (var index in this.selected) {
          var item = this.selected[index]
          this.setEmailNotification(item, false)
        }
        this.selected = []
      } else {
        this.selected = this.tableDataBL.slice()
        for (var index1 in this.selected) {
          var item1 = this.selected[index1]
          this.setEmailNotification(item1, true)
        }
      }
    },
    parseDate: function (dateStr) {
      var d = moment(dateStr)
      return d
    },
    downloadDocumentWithTypExists (docType, row) {
      var value = row['docTypes']
      var result = []
      if (value) {
        result = value.split(',')
        if (!result) {
          result = []
        }
      }
      var found = false
      _.forEach(result, function (head) {
        if (docType === head) {
          found = true
        }
      })
      return found
    },
    dayDiff (date1, date2) {
      let dayDifference = date1.diff(date2, 'days')
      return dayDifference
    },
    /* Änderungen */
    onGetChangelogs: function (data) {
      Vue.prototype.$api.debug('onGetChangelogs', data)
      if (data.array === null) {
        data.array = []
      }
      this.tableData = data.array
      var current = new Date()
      var lastGroup = null
      for (var index in this.tableData) {
        var item = this.tableData[index]
        item.isEmail = item.email === '1'
        item.dayCount = this.dayDiff(moment(current), this.parseDate(item.datumZeit))
        var text = Vue.i18n.translate('TABLE_LINE_LATER')

        if (item.dayCount <= 30) {
          text = Vue.i18n.translate('TABLE_LINE_LAST_MONTH')
        }
        if (item.dayCount <= 7) {
          text = Vue.i18n.translate('TABLE_LINE_LAST_WEEK')
        }
        if (item.dayCount <= 1) {
          text = Vue.i18n.translate('TABLE_LINE_TODAY')
        }
        if (lastGroup !== text) {
          item.diffText = text
          lastGroup = item.diffText
        } else {
          item.diffText = null
        }
      }
      Vue.prototype.$api.hideIdle()
    },
    onGetBankData (item) {
      Vue.prototype.$api.debug('onGetBankData', item, this.currentItem)
      Vue.prototype.$api.hideIdle()
      var param = {
        year: '' + this.currentItem.Jahr,
        crefoNr: this.currentItem.CrefoNr,
        bankBalanceDate: item.bilanzDate,
        balanceDate: item.bilanzDate,
        rechtskreis: this.currentItem.RechtskreisNr,
        abschlussart: this.currentItem.AbschlussartNr,
        guid: item.bankID,
        isForwardItem: true,
        hasAnkerbank: false,
        bankCurrency: item.bankCurrency + '',
        currency: item.bankCurrency + '',
        currencyDim: item.bankCurrencyDim + '',
        country: this.currentItem.country,
        region: this.currentItem.region,
        balanceSum: item.bankBalanceSums,
        orderNr: item.orderNr,
        sourceNr: item.sourceNr,
        ultimateMother: item.ultimateMother,
        lastChanged: item.lastChanged,
        name: this.currentItem.name,
        branch: this.currentItem.BranchenkategorieNr
      }
      item.isAnkerbank = true
      Vue.prototype.storage.ankerBank = param
      this.$router.push({name: 'AnkerbankDetails', params: param})
    },
    checkAbschlussExists (item) {
      this.currentItem = item
      var balance = {
        aaNr: item.AbschlussartNr,
        crefoNr: item.CrefoNr,
        rkNr: item.RechtskreisNr,
        source: item.QuelleNr,
        year: item.Jahr
      }
      console.log('checkAbschlussExists', item, balance)
      Vue.prototype.$api.checkBalanceExists(balance, this.onGetAbschlussExists)
    },
    onGetAbschlussExists (resp) {
      if (resp.success) {
        this.openItem(this.currentItem)
      } else {
        this.$refs.dlg.show({
          title: Vue.i18n.translate('DIALOG_TITLE_MISSING_BALANCE'),
          text: Vue.i18n.translate('DIALOG_TEXT_MISSING_BALANCE')
        })
      }
    },
    openItem (item) {
      if (item.Aenderungsgrund === '3') {
        console.error('openItem denied', item)
        return
      }
      var balance = {
        aaNr: item.AbschlussartNr,
        crefoNr: item.CrefoNr,
        rkNr: item.RechtskreisNr,
        source: item.QuelleNr,
        year: item.Jahr
      }
      console.log('openItem', item, balance)
      // var url = ' balance.aaNr + '/' + balance.crefoNr + '/' + balance.rkNr + '/' + balance.source + '/' + balance.year
      var url = '/Forward?url=' + Vue.prototype.$api.getStructureUrl(this.idModule, balance)
      Vue.prototype.$api.debug('url', url)
      this.$router.push({ path:url, meta: {
          forward: true
        }})
      this.currentItem = item
    },
    getValue (item, _header) {
      var value = item[_header.value]
      if (_header.value === 'RechtskreisNr') {
        var e = Vue.prototype.$api.getI18NRechtsKreis(item.RechtskreisNr)
        if (e) value = e.title
      }
      if (_header.value === 'Aenderungsgrund') {
        e = Vue.prototype.$api.getI18NAenderungsgrund(item.Aenderungsgrund)
        if (e) value = e.title
      }
      if (_header.value === 'QuelleNr') {
        e = Vue.prototype.$api.getI18NQuelle(item.QuelleNr)
        if (e) value = e.lanValue
      }
      if (_header.value === 'branch') {
        e = Vue.prototype.$api.getI18NBranche(item.branch)
        if (e) value = e.title
      }
      if (_header.value === 'country') {
        e = Vue.prototype.$api.getI18NCountry(item.country)
        if (e) {
          return e.title
        }
      }
      if (_header.value === 'region') {
        e = Vue.prototype.$api.getI18NRegion(item.region)
        if (e) {
          return e.title
        }
      }
      if (_header.value === 'datumZeit') {
        if (value) {
          return moment(String(value)).format('DD.MM.YYYY HH:mm')
        }
      }

      if (_header.value === 'docTypes') {
        var types = value.split(',')
        var html = ''
        for (var index in types) {
          var items = types[index]
          // html = html + '<img style="margin-right:10px;padding-top:4px; height:20px;" src="static/pdf.png"/>'
          // html = html + '<span class="tableDownloadPDF handpointer" key="index" documentIndex="index" text="item.DokumententypNr + item.year+ item.label" title="item.DokumententypNr + item.year+ item.label"> <v-icon>get_app</v-icon></span>'
        }
        return html
        //
      }
      if (_header.value === 'AbschlussartNr') {
        e = Vue.prototype.$api.getI18NAbschlussart(item.AbschlussartNr)
        if (e) value = e.title
      }
      if (_header.value === 'balanceSum') {
        if (!Number.isFinite(value)) {
          var maximumFractionDigits = 2
          var minimumFractionDigits = 2
          value = (1 * value).toLocaleString('de-DE', {
            style: 'decimal',
            useGrouping: true,
            maximumFractionDigits: maximumFractionDigits,
            minimumFractionDigits: minimumFractionDigits
          })
        }
      }
      if (item.isAnkerBank) {
        var v = value
        if (!v) v = ''
        return '<b>' + v + '</b>'
      }
      return value
    },
    getHeaderClass (header) {
      if (header.value === 'balanceSum') {
        return 'text-xs-right'
      }
      return 'text-xs-left'
    },
    getClassFor (header) {
      if (header.value === 'balanceSum') {
        return 'text-xs-right'
      }
      return 'text-xs-left'
    },
    open: function () {
    },
    onChangeLogs: function () {
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.getChangeLogs(this.onGetChangelogs, this.onGetChangelogs)
    }
  },
  data () {
    return {
      cellspan: 6,
      idModule: '',
      mockData: {"maxsize":null,"size":36,"array":[{"CrefoNr":"400992273","Jahr":"2017","RechtskreisNr":"45","rk":"Bankbilanz IFRS 9","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2021-03-05 14:55:55","email":"1","modulID":"banks","name":"Agricultural Bank of China Limited","country":"63","region":"Asien","BranchenkategorieNr":"118","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400992273","Jahr":"2015","RechtskreisNr":"45","rk":"Bankbilanz IFRS 9","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2021-03-05 14:50:45","email":"1","modulID":"banks","name":"Agricultural Bank of China Limited","country":"63","region":"Asien","BranchenkategorieNr":"118","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400992273","Jahr":"2015","RechtskreisNr":"45","rk":"Bankbilanz IFRS 9","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"3","datumZeit":"2021-03-05 14:50:45","email":"1","modulID":"banks","name":"Agricultural Bank of China Limited","country":"63","region":"Asien","BranchenkategorieNr":"118","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400985871","Jahr":"2017","RechtskreisNr":"89","rk":"Bankbilanz IAS 39","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2021-03-05 12:54:21","email":"1","modulID":"banks","name":"ACLEDA MFI Myanmar Co Ltd","country":"161","region":"Asien","BranchenkategorieNr":"129","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400985871","Jahr":"2019","RechtskreisNr":"117","rk":"Bankbilanz Rumpf National-IAS 39","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2021-01-20 15:00:29","email":"1","modulID":"banks","name":"ACLEDA MFI Myanmar Co Ltd","country":"161","region":"Asien","BranchenkategorieNr":"129","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400985871","Jahr":"2020","RechtskreisNr":"90","rk":"Bankbilanz National-IAS 39","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2021-01-20 14:56:26","email":"1","modulID":"banks","name":"ACLEDA MFI Myanmar Co Ltd","country":"161","region":"Asien","BranchenkategorieNr":"129","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"2150535707","Jahr":"2019","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2020-12-03 09:05:38","email":"1","modulID":"banks","name":"Bank Deutsches Kraftfahrzeuggewerbe GmbH","country":"1","region":"Westeuropa","BranchenkategorieNr":"119","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"2150535707","Jahr":"2018","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2020-12-03 08:52:03","email":"1","modulID":"banks","name":"Bank Deutsches Kraftfahrzeuggewerbe GmbH","country":"1","region":"Westeuropa","BranchenkategorieNr":"119","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400985871","Jahr":"2017","RechtskreisNr":"90","rk":"Bankbilanz National-IAS 39","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2020-10-08 10:24:57","email":"1","modulID":"banks","name":"ACLEDA MFI Myanmar Co Ltd","country":"161","region":"Asien","BranchenkategorieNr":"129","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400985871","Jahr":"2015","RechtskreisNr":"90","rk":"Bankbilanz National-IAS 39","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2020-10-07 14:17:18","email":"1","modulID":"banks","name":"ACLEDA MFI Myanmar Co Ltd","country":"161","region":"Asien","BranchenkategorieNr":"129","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400985871","Jahr":"2016","RechtskreisNr":"90","rk":"Bankbilanz National-IAS 39","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2020-10-07 14:17:18","email":"1","modulID":"banks","name":"ACLEDA MFI Myanmar Co Ltd","country":"161","region":"Asien","BranchenkategorieNr":"129","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400985871","Jahr":"2014","RechtskreisNr":"90","rk":"Bankbilanz National-IAS 39","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2020-08-06 14:14:47","email":"1","modulID":"banks","name":"ACLEDA MFI Myanmar Co Ltd","country":"161","region":"Asien","BranchenkategorieNr":"129","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"6070013730","Jahr":"2019","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2020-07-09 10:30:28","email":"1","modulID":"banks","name":"Hauck & Aufhauser Privatbankiers Aktiengesellschaft","country":"1","region":"Westeuropa","BranchenkategorieNr":"127","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400986116","Jahr":"2019","RechtskreisNr":"45","rk":"Bankbilanz IFRS 9","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2020-06-03 15:11:33","email":"1","modulID":"banks","name":"DEPFA BANK plc","country":"58","region":"Nordeuropa","BranchenkategorieNr":"131","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400986116","Jahr":"0","RechtskreisNr":"0","rk":"0","QuelleNr":"1","AbschlussartNr":"0","Aenderungsgrund":"4","datumZeit":"2020-05-19 18:08:00","email":"1","modulID":"banks","name":"DEPFA BANK plc","country":"58","region":"Nordeuropa","BranchenkategorieNr":"131","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"5030147200","Jahr":"2014","RechtskreisNr":"89","rk":"Bankbilanz IAS 39","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2019-10-07 09:25:26","email":"1","modulID":"banks","name":"Deutsche Postbank AG","country":"1","region":"Westeuropa","BranchenkategorieNr":"131","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400986116","Jahr":"2015","RechtskreisNr":"89","rk":"Bankbilanz IAS 39","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2019-10-07 09:16:28","email":"1","modulID":"banks","name":"DEPFA BANK plc","country":"58","region":"Nordeuropa","BranchenkategorieNr":"131","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400986116","Jahr":"2016","RechtskreisNr":"89","rk":"Bankbilanz IAS 39","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2019-10-07 09:13:13","email":"1","modulID":"banks","name":"DEPFA BANK plc","country":"58","region":"Nordeuropa","BranchenkategorieNr":"131","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400985871","Jahr":"2018","RechtskreisNr":"90","rk":"Bankbilanz National-IAS 39","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2019-09-19 09:51:51","email":"1","modulID":"banks","name":"ACLEDA MFI Myanmar Co Ltd","country":"161","region":"Asien","BranchenkategorieNr":"129","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400985871","Jahr":"2019","RechtskreisNr":"90","rk":"Bankbilanz National-IAS 39","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2019-09-19 09:51:51","email":"1","modulID":"banks","name":"ACLEDA MFI Myanmar Co Ltd","country":"161","region":"Asien","BranchenkategorieNr":"129","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"400986116","Jahr":"2018","RechtskreisNr":"45","rk":"Bankbilanz IFRS 9","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2019-09-03 09:17:39","email":"1","modulID":"banks","name":"DEPFA BANK plc","country":"58","region":"Nordeuropa","BranchenkategorieNr":"131","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"6070013730","Jahr":"2018","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2019-08-03 06:55:31","email":"1","modulID":"banks","name":"Hauck & Aufhauser Privatbankiers Aktiengesellschaft","country":"1","region":"Westeuropa","BranchenkategorieNr":"127","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"6070013730","Jahr":"2012","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2018-12-03 08:25:23","email":"1","modulID":"banks","name":"Hauck & Aufhauser Privatbankiers Aktiengesellschaft","country":"1","region":"Westeuropa","BranchenkategorieNr":"127","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"6070013730","Jahr":"2013","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2018-11-28 14:46:07","email":"1","modulID":"banks","name":"Hauck & Aufhauser Privatbankiers Aktiengesellschaft","country":"1","region":"Westeuropa","BranchenkategorieNr":"127","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"6070013730","Jahr":"2014","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2018-11-28 10:27:53","email":"1","modulID":"banks","name":"Hauck & Aufhauser Privatbankiers Aktiengesellschaft","country":"1","region":"Westeuropa","BranchenkategorieNr":"127","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"6070013730","Jahr":"2015","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2018-11-28 07:28:47","email":"1","modulID":"banks","name":"Hauck & Aufhauser Privatbankiers Aktiengesellschaft","country":"1","region":"Westeuropa","BranchenkategorieNr":"127","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"6070013730","Jahr":"2016","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2018-11-27 13:13:19","email":"1","modulID":"banks","name":"Hauck & Aufhauser Privatbankiers Aktiengesellschaft","country":"1","region":"Westeuropa","BranchenkategorieNr":"127","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"6070013730","Jahr":"2017","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"2","Aenderungsgrund":"1","datumZeit":"2018-11-27 13:13:19","email":"1","modulID":"banks","name":"Hauck & Aufhauser Privatbankiers Aktiengesellschaft","country":"1","region":"Westeuropa","BranchenkategorieNr":"127","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"5030147200","Jahr":"2014","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2018-08-28 14:23:26","email":"1","modulID":"banks","name":"Deutsche Postbank AG","country":"1","region":"Westeuropa","BranchenkategorieNr":"131","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"5030147200","Jahr":"2015","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2018-07-16 13:51:40","email":"1","modulID":"banks","name":"Deutsche Postbank AG","country":"1","region":"Westeuropa","BranchenkategorieNr":"131","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"5030147200","Jahr":"2016","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2018-07-16 08:01:17","email":"1","modulID":"banks","name":"Deutsche Postbank AG","country":"1","region":"Westeuropa","BranchenkategorieNr":"131","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"5030147200","Jahr":"2017","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2018-07-16 08:01:16","email":"1","modulID":"banks","name":"Deutsche Postbank AG","country":"1","region":"Westeuropa","BranchenkategorieNr":"131","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"6070065784","Jahr":"2015","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"3","datumZeit":"2017-04-21 10:53:36","email":"1","modulID":"banks","name":"Commerzbank AG","country":"1","region":"Westeuropa","BranchenkategorieNr":"131","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"6070000944","Jahr":"2013","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"3","datumZeit":"2017-04-21 10:53:29","email":"1","modulID":"banks","name":"Deutsche Bank AG","country":"1","region":"Westeuropa","BranchenkategorieNr":"123","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"6070000944","Jahr":"2014","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"3","datumZeit":"2017-04-21 10:53:29","email":"1","modulID":"banks","name":"Deutsche Bank AG","country":"1","region":"Westeuropa","BranchenkategorieNr":"123","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""},{"CrefoNr":"6070000944","Jahr":"2013","RechtskreisNr":"43","rk":"Bankbilanz HGB","QuelleNr":"1","AbschlussartNr":"1","Aenderungsgrund":"1","datumZeit":"2016-09-28 10:33:32","email":"1","modulID":"banks","name":"Deutsche Bank AG","country":"1","region":"Westeuropa","BranchenkategorieNr":"123","id":"","auftragNr":"","hgpNr":"","docOrders":"","docTypes":""}],"debug":null,"success":true,"simpleAnswer":null,"tableUserAlertAenderungEvaluerateExistsPrivate":false,"tableUserAlertAenderungEvaluerateExistsPublic":true,"tableKundeEvaluerateExists":false},
      ankerBank: null,
      tabModel: 0,
      hasAnkerBank: false,
      emailSet: [
        {text: Vue.i18n.translate('EMAIL_JA'), id: '1'},
        {text: Vue.i18n.translate('EMAIL_NEIN'), id: '0'}
      ],
      // Name, CrefoNr./HGP-Nr., Region, Land, E-Mail-Benachrichtigung (an/aus)
      crefoDoubleExists: false,
      pagination: {
        rowsPerPage: 5000,
        descending: true,
        sortBy: 'year'
      },
      tableData: [],
      tableDataBL: [],
      countries: [],
      selected: [],
      //  Name, CrefoNr./HGP-Nr., Abschlussart, Rechtskreis, Jahr, Quelle, Datum, Änderungsgrund
      headers: []
    }
  },
  mounted () {
    var cmp = this
    this.idModule = Vue.prototype.$api.getModuleId()
    cmp.headers.push({text: Vue.i18n.translate('CELL_TITLE_NAME'), value: 'name', sortable: false})
    cmp.headers.push({text: Vue.i18n.translate('CELL_TITLE_CREFONR'), value: 'CrefoNr', sortable: false})
    if (Vue.prototype.$api.getParamData().clientNr === '361') {
      cmp.headers.push({text: Vue.i18n.translate('CELL_TITLE_HGPNR'), value: 'hgpNr', sortable: false})
    }
    cmp.headers.push({text: Vue.i18n.translate('CELL_TITLE_ABSCHLUSS'), value: 'AbschlussartNr', sortable: false})
    cmp.headers.push({text: Vue.i18n.translate('CELL_TITLE_RECHTSKREIS'), value: 'rk', sortable: false})
    cmp.headers.push({text: Vue.i18n.translate('CELL_TITLE_JAHR'), value: 'Jahr', sortable: false})
    cmp.headers.push({text: Vue.i18n.translate('CELL_TITLE_QUELLE'), value: 'QuelleNr', sortable: false})
    cmp.headers.push({text: Vue.i18n.translate('CELL_TITLE_DATUM'), value: 'datumZeit', sortable: false})
    cmp.headers.push({text: Vue.i18n.translate('CELL_TITLE_GRUND'), value: 'Aenderungsgrund', sortable: false})
    if (this.idModule === "banks" || Vue.prototype.$api.getParamData().clientNr === '361' ) {
      cmp.headers.push({text: Vue.i18n.translate('CELL_TITLE_BERICHT'), value: 'docTypes', sortable: false})
    }
    cmp.onChangeLogs()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/changelog/NewsboxChanges.vue